// extracted by mini-css-extract-plugin
export default {"recentUpdates":"RecentUpdates_recentUpdates__6tSKK","text":"RecentUpdates_text__eIc+l","cards":"RecentUpdates_cards__pGs-1"};